import React from "react";
import { Commet } from "react-loading-indicators";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <Commet color="var(--theme-secondary)" type="ball-scale" size="medium" text="" textColor="" />
    </div>
  );
};

export default Loader;